import { SyncFrequency, syncFrequencyLabels } from 'shared/interfaces/Resource';

export function convertMsToSyncFrequency(syncFrequencyMs: number): SyncFrequency {
  const oneDayMs = 24 * 60 * 60 * 1000;
  const threeDaysMs = 3 * oneDayMs;
  const sevenDaysMs = 7 * oneDayMs;
  const oneMonthMs = 30 * oneDayMs;

  if (syncFrequencyMs === oneDayMs) {
    return SyncFrequency.ONE_DAY;
  } else if (syncFrequencyMs === threeDaysMs) {
    return SyncFrequency.THREE_DAYS;
  } else if (syncFrequencyMs === sevenDaysMs) {
    return SyncFrequency.SEVEN_DAYS;
  } else if (syncFrequencyMs === oneMonthMs) {
    return SyncFrequency.ONE_MONTH;
  } else {
    return SyncFrequency.NEVER;
  }
}

export const syncFrequencyOptions = Object.entries(syncFrequencyLabels).map(([value, label]) => ({
  label,
  value
}));
